const ROUTES = {
  LOGIN: 'login',
  DASHBOARD: 'dashboard',
  EMPTY: 'empty',
  IMPORT: 'import',
  IMPORT_NEW: 'import-new',
  PAYMENT_NEW: 'payment-new',
  APPROVE: 'approve',
  PAYMENTS: 'payments',
  DETAILS: 'details',
  BATCH_DETAILS: 'batch-details',
  PAYMENT_LOGS: 'payment-logs',
  COMPANIES: 'companies',
  COMPANY_SYNC_LOGS: 'company-sync-logs',
  COMPANY_CREDITORS: 'company-creditors',
  COMPANY_NEW: 'company-new',
  TEMPLATES: 'templates',
  TEMPLATE_NEW: 'template-new',
  USERS: 'users',
  PROFILE: 'profile',
  SETTINGS: 'settings',
};

const BODY_ID_BY_ROUTE = {
  [ROUTES.LOGIN]: 'page-login',
  [ROUTES.DASHBOARD]: 'page-dashboard',
  [ROUTES.EMPTY]: 'page-empty',
  [ROUTES.IMPORT]: 'page-newpayment',
  [ROUTES.IMPORT_NEW]: 'page-newpayment',
  [ROUTES.PAYMENT_NEW]: 'page-newpayment',
  [ROUTES.APPROVE]: 'page-approve',
  [ROUTES.PAYMENTS]: 'page-payments',
  [ROUTES.DETAILS]: 'page-batch-details',
  [ROUTES.BATCH_DETAILS]: 'page-batch-details',
  [ROUTES.PAYMENT_LOGS]: 'page-payment-logs',
  [ROUTES.COMPANIES]: 'list-empresas',
  [ROUTES.COMPANY_SYNC_LOGS]: 'page-sync-logs',
  [ROUTES.COMPANY_CREDITORS]: 'list-creditores',
  [ROUTES.COMPANY_NEW]: 'form-empresas',
  [ROUTES.TEMPLATES]: 'list-arquetipo',
  [ROUTES.TEMPLATE_NEW]: 'form-arquetipo',
  [ROUTES.USERS]: 'list-usuarios',
  [ROUTES.PROFILE]: 'form-usuarios',
  [ROUTES.SETTINGS]: 'form-config',
};

const ROUTE_FOR_NAV = {
  dashboard: ROUTES.DASHBOARD,
  approve: ROUTES.APPROVE,
  payments: ROUTES.PAYMENTS,
  creditors: ROUTES.COMPANY_CREDITORS,
  companies: ROUTES.COMPANIES,
  templates: ROUTES.TEMPLATES,
  users: ROUTES.USERS,
};

export { ROUTES, BODY_ID_BY_ROUTE, ROUTE_FOR_NAV };
